import PaymentWizardPage from './PaymentWizardPage';

export default PaymentWizardPage;
